module.exports = __webpack_public_path__ + "img/packaging.3b17b55f.svg";